<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1ti6zr/tc-custom/9781615954636.jpg?1731883366322" alt="This image is the cover for the book Covenant with Hell, Medieval Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Covenant with Hell, Medieval Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p>In the Spring of 1277, Prioress Eleanor goes on a pilgrimage to a famous East Anglian shrine. There are rumors that King Edward may also visit the shrine soon to seek God's blessing for his invasion of Wales. Lurking in this sacred place, however, is an assassin hoping to murder a king.</p><p>Soon after Prioress Eleanor and Brother Thomas arrive, a nun falls to her death from the priory bell tower. Brother Thomas finds the body, and the pair quickly grasp that this nun's death was not a simple tragedy. The circumstances point to murder, but this slaying is further tainted with treason. Among the pilgrims, merchants, and religious, too many betray an interest in this death—including a canny street child. At least one of them is most certainly a killer.</p><p>Can Prioress Eleanor and Brother Thomas succeed in exposing the assassin or will they also fall victim to one who has made a covenant with hell?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Priscilla Royal
      </h2>
      
      <p class="authorDescription body article"><P>Priscilla Royal grew up in British Columbia and earned a B.A. in World Literature at San Francisco State University, where she discovered the beauty of medieval literature. She is a theater fan as well as a reader of history, mystery, and fiction of lesser violence. When not hiding in the thirteenth century, she lives in Northern California and is a member of California Writers Club, Mystery Writers of America, and Sisters in Crime.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2fe117e8